//登録フロー：メールアドレスパスワード認証用メールアドレス認証処理 /email_register2
import React, { Component } from 'react';
import Header from './header'
import Footer from './footer'
import { Link,browserHistory } from 'react-router'
import './css/emailRegister2.css';
import './css/toast_custom.css';
import firebase from 'firebase'
import { IsLoading } from './loading';
import Toast from './components/toast'
import validator from 'email-validator';
import define from './define';

const delimiter = '{{{{{}}}}}';

export default class emailRegister2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      sendSuccess: false,
      validateResult: '',
      isLoad: false,
      errorMessage: '',
      isRender: true,
    }
  }

  checkIsQuery = () => {
    // クエリパラメータがあれば、有効期限チェック、なければなにもしない
    // 有効期限内であればパスワード登録へ
    const { location　} = this.props;
    const query = location.query.m;
    if (query) {
      const decodeArr = this.decoding(query);
      const now = Date.now();
      // within 24h
      if (now - decodeArr[1] <= 1000 * 60 * 60 * 24) {
        // 有効期限内
        this.setState({ isRender: false })
        browserHistory.push({
          pathname: '/passwordRegister',
          state: { email: decodeArr[0] }
        });
      } else {
        this.setState({errorMessage: <div className="toast-caution"><p>このリンクは有効期限切れです</p></div>})
      }
    }
  }

  componentWillMount = () => {
    this.checkIsQuery();
  }

  handleChangeEmail = (e) => {
    const target = e.currentTarget;
    this.setState({ email: target.value });
  }

  onConfirm = (e) => {
    e.preventDefault();
    const { email } = this.state;
    if (undefined === email || 0 === email.trim().length) {
      this.setState({ validateResult: '※メールアドレスを入力してください' })
    } else if (!validator.validate(email)) {
      this.setState({ validateResult: '※正しいメールアドレスを入力してください' })
    } else {
      // search email
      const headers = new Headers()
      headers.append('Content-Type','application/json');
      const endPoint = `/api/searchEmail?email=${email}`
      const options = {
        method:'GET',
        headers,
      }

      fetch(endPoint, options)
      .then(res => {
        return res.json()
      })
      .then(body => {
        if (body.isEmail) {
          this.setState({validateResult:'※既にご登録のあるメールアドレスです'});
          return
        }
        this.setState({ isLoad: true });
        this.sendMailForCheckEmail(email);
      })
    }
  }

  // to create query
  encoding = (email) => {
   return Buffer.from(email + delimiter + Date.now()).toString('base64');
  }

  // to decode query
  decoding = (query) => {
    const arr = Buffer.from(query,'base64').toString().split(delimiter);
    return arr;
  }

  //確認メールを送信
  sendMailForCheckEmail = (to) => {
    const mailSubject = 'MyRate | メールアドレス登録認証用メール'
    const createParam = '?m=' + this.encoding(to)
    const mailBody = '下記のURLをクリックしてメールアドレスの登録を完了させてください。\nなお、この認証メールのURLをクリックするまでは、登録は完了しません。\n' + window.location.origin + '/email_register2' + createParam + '\n※リンクの有効期限は、発行してから24時間となります。'
    const params = {
      'sendToUsers': [to],
      'mailSubject': mailSubject,
      'mailBody': mailBody,
    }
    // テスト、ベトナム環境ではメールが飛ばないためリンク出力
    const { projectId } = define.FIREBASE_CONFIG;
    if ('localhost' !== window.location.hostname && ('n-lisence-local'=== projectId || 'n-license-apv' === projectId)) {
      console.log(window.location.origin + '/email_register2' + createParam);
      this.setState({ isLoad: false });
      this.setState({ sendSuccess: true });
      return;
    }
    
    const headers = new Headers()
    headers.append('Content-Type','application/json');
    const endPoint = '/api/sendmail'
    const options = {
      method:'POST',
      headers,
      body: JSON.stringify(params)
    }
    fetch(endPoint, options)
      .then(res => {
        this.setState({ isLoad: false });
        return res.json();
      })
      .then(json => {
        if (!json.res.error.length) {
          this.setState({ sendSuccess: true });
        }
      })
      .catch(error => {
        alert('エラーが発生しました')
        this.setState({ isLoad: false });
      })
  }  

  returnToast = () => {
    const { errorMessage } = this.state;
    if (errorMessage) {
      return (
        <Toast notifyMessage={ errorMessage } />
      )
    }
  }

  showEmailInput = () => {
    const { email } = this.state;
    return (
      <div className="form-tel">
        <input value={email} type="text" name="code" className="tel" onChange={this.handleChangeEmail} />
      </div>
    )
  }

  showContent = () => {
    const {
      sendSuccess,
      validateResult,
      isLoad
    } = this.state;
    if (isLoad) {
      return (
        <div>
          { IsLoading() }
        </div>
      )
    } else {
      if (sendSuccess) {
        return (
          <div>
            <p className="subtitle">入力されたメールアドレス宛に<br/>認証用のメールを送信しました！</p>
            <div className="text-notification">
              <p>メールに記載された認証URLをクリックし、認証を行ってください。なお、認証URLをクリックするまでは、登録は完了しません。<br/>※リンクの有効期限は、発行してから24時間となります。</p>
            </div>
          </div>
        )
      }
      return (
        <div>
          {this.returnToast()}
          <p className="subtitle">メールアドレスを登録しよう！</p>
          <p className="warning">{validateResult}</p>
          {this.showEmailInput()}
          <div className="text-notification">
            <p>MyRateアカウントを作成するには、メールアドレスの登録が必要です。使用可能なメールアドレスを入力ください。</p>
          </div>
          <div className="btnAction">
            <Link onClick={this.onConfirm} className="btn-connect">次へ</Link>
          </div>
        </div>
      )
    }
  }
  
  render () {
    if (!this.state.isRender) {
      return null;
    } 
    return (
      <div id="wrapper">
        <div id="" className="wrapper-lp wrapper-email-register2">
          {/* <Header parentProps={this.props} /> */}
          <Header />
          <div className="webWrap">
            <div className="wrapCover">
              <div className="wrapCover__contentBlock clearfix">
                <div className="content-top">
                  <div className="block-email-register2">
                    <h2 className="title">Sign Up</h2>
                    <img className="step_icon" src="/img/common/step-1@2x.png" alt="" />
                    <img className="title_icon" src="/img/common/img_mail.png" alt="" />
                    {this.showContent()}
                  </div>
                </div>
              </div>
              <Footer/>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/email_register2.js